import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core'
import { Gridster, GridsterItem, GridsterPush } from 'angular-gridster2'
import * as _ from 'lodash'
import moment from 'moment'

import { FilterService } from 'src/app/services/filter.service'
import { WidgetService } from '../../../services/widget.service'
import { DeviceDetectionService } from 'src/app/services/detectipad.service'
import { FilterBadgesComponent } from '../filter-badges/filter-badges.component'
import { ShowByCardComponent } from '../show-by-card/show-by-card.component'
import { AlertButton } from '../alert-button/alert-button'
import { FilterButton } from '../filter-button/filter-button'
import { WidgetConfig, keysByType, Copyright as CopyrightWidgetConfig } from '../widget.model'
import config, { GridsterConfig } from './config'
import { InfoIconComponent } from '../info-icon/info-icon.component'
import { WidgetTextNotesComponent } from '../text-notes/text-notes.component'
import { FilterComponent } from '../filter/filter.component'
import { ActivatedRoute } from '@angular/router'
import { NavigationService } from 'src/app/services/navigation.service'
import { ServerSideListComponent } from '../server-side-list/server-side-list.component'
import { PatientGridListComponent } from '../patient-grid-list/patient-grid-list.component'
import { DashboardService } from 'src/app/services/dashboard.service'
import { PageDataService } from 'src/app/services/page-data.service'
import { RequestCancelService } from 'src/app/services/request-cancel.service'

@Component({
    selector: 'app-grid-page',
    templateUrl: './grid-page.component.html',
    styleUrls: ['./grid-page.component.scss'],
    standalone: false
})
export class GridPageComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('designMode') designMode = false
  @Input('pageInfo') pageInfo: any = {}
  @ViewChildren(GridsterItem) gridsterItems!: QueryList<GridsterItem>;
  @ViewChild(Gridster) gridster?: Gridster;

  options: GridsterConfig = config
  widgets: WidgetConfig[] = []
  kpiCardWidgets: WidgetConfig[] = []
  informationCardWidgets: WidgetConfig[] = []
  commonWidgets: WidgetConfig[] = []
  textNotesWidget: WidgetConfig | undefined
  filterWidgetConfig: WidgetConfig | undefined
  // The empty tile appended below the last widget; see ngOnInit
  bottomSpacer: WidgetConfig | undefined
  // Widgets the designer placed side by side with the same top and height, each mapped to
  // every widget in its row (itself included); see buildRowGroups
  private rowGroups = new Map<WidgetConfig, WidgetConfig[]>()
  // Rows each widget's content last asked for, through onSizeChange
  private contentRows = new Map<WidgetConfig, number>()
  // Tablet/mobile, by device: the KPI and information cards sit in a scrolling row above the
  // grid instead of having tiles (mobileHide)
  compactLayout = false
  // A desktop grid narrower than gridster's mobileBreakpoint (640px). Gridster stacks every
  // tile full width there, which collapsed the KPI cards to slivers, so while it lasts their
  // tiles are styled as the scrolling card row the tablet layout uses (.du-card-strip)
  narrowGrid = false
  // The tiles, split so the KPI / information cards can share that wrapper. Only CSS changes
  // when narrowGrid flips - moving the cards into a different row recreated their
  // components, and the ones that only load on filterQuery then never loaded again.
  cardTiles: WidgetConfig[] = []
  otherTiles: WidgetConfig[] = []
  showLoader = false;
  extract_hide_flg:any;

  isMobile = false;
  isTablet = false;
  isDesktop = false;
  dashboardKey: any;
  tabId:any = 0;

  protected readonly keysByType = keysByType

  constructor (
    public filterService: FilterService,
    public widgetService: WidgetService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    public deviceDetectionService: DeviceDetectionService,
    private cdr: ChangeDetectorRef,
    private dashboardService: DashboardService,
    private pageDataService: PageDataService,
    private requestCancelService: RequestCancelService
  ) {
    this.widgetService.showLessAndMore.subscribe(flag => this.showLessMore = flag);
    this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
      this.tabId = params["tab_id"];
      this.extract_hide_flg = decryptedParams["hd_flg"];
      this.dashboardKey = decryptedParams["ds_key"];
      
    });

    this.dashboardService.sidebarSizeEventChanges.subscribe((f:any)=> {
      this.onResize()
    })
  }

  moment = moment
  showLessMore = false

  ngOnInit () {
    if (!this.pageInfo.page_config_details) return

    // debugger

    this.filterService.baseQuery = {} // empty the baseQuery from the filter
    let widgets: WidgetConfig[] = JSON.parse(this.pageInfo.page_config_details);

    if(this.extract_hide_flg=='N') {
      const fndIndex = widgets.findIndex((o:any)=> o.config?.['hideWidgets'] && o.config?.['hideWidgets']?.name == 'Yes');
      if(fndIndex!=-1) {
        widgets.splice(fndIndex, 1);
      }
    }

    // sort widgets vertically
    widgets = widgets.sort((w1, w2) => w1.y - w2.y)

    // Tablet/mobile lay the header + common widgets out in fixed rows above the
    // grid (see the template); desktop gives every widget a gridster tile.
    const isCompactLayout = this.deviceDetectionService.isTablet || this.deviceDetectionService.isMobile
    this.compactLayout = isCompactLayout

    const platformSpecific = _.filter(widgets, w => (
      keysByType[isCompactLayout ? 'mobileHide' : 'desktopHide'].includes(w.key)
    ))

    const filterBadges = _.find(widgets, { key: FilterBadgesComponent.key })
    if (filterBadges) filterBadges.layerIndex = 2

    const headerWidgets = widgets.filter(w => w.checked)
    let sortedHeaderWidgets: WidgetConfig[] = []
    if (headerWidgets.length) {
      sortedHeaderWidgets = [...headerWidgets] // Create a copy to avoid direct manipulation
      sortedHeaderWidgets.sort((w1, w2) => (w1.key === FilterBadgesComponent.key ? -1 : w2.key === FilterBadgesComponent.key ? 1 : 0))
      sortedHeaderWidgets.sort((w1, w2) => (w1.key === FilterButton.key ? 1 : w2.key === FilterButton.key ? -1 : 0))
    }
    this.textNotesWidget = _.find(sortedHeaderWidgets, { key: WidgetTextNotesComponent.key })

    this.filterWidgetConfig = widgets.find(w => [FilterComponent.key, FilterButton.key].includes(w.key))
    this.filterService.showByInGrid = !!widgets.find(w => w.key === ShowByCardComponent.key)
    // Widgets promoted to the page header. pages.component renders these itself,
    // on every device, so they are what the rows below must not repeat.
    const pageHeaderWidgets = _.filter(sortedHeaderWidgets, w => keysByType.pageHeader.includes(w.key))
    // TODO there should be a better way to set widget for the page header
    setTimeout(() => {
      this.widgetService.pageHeaderWidgets = pageHeaderWidgets
      this.widgetService.filterIcon = !!this.filterWidgetConfig && this.filterWidgetConfig.key === FilterButton.key
      this.widgetService.alertIcon = !!_.find(widgets, { key: AlertButton.key })
    }, 100)

    // The common row is only rendered on tablet/mobile, and the page header is
    // rendered everywhere - so a widget in both groups was drawn twice there.
    // Time cycle and show-by sit in `common` AND `pageHeader`, which is exactly
    // the pair that showed up twice on iPad. The page header wins: that keeps a
    // promoted widget in the same place on iPad as on desktop.
    const commonWidgets = _.difference(
      _.filter(widgets, w => keysByType.common.includes(w.key)),
      pageHeaderWidgets
    )
    this.kpiCardWidgets = _.sortBy(_.filter(widgets, w => keysByType.kpiCard.includes(w.key)), 'x')
    this.informationCardWidgets = _.filter(widgets, w => keysByType.informationCard.includes(w.key))

    const gestureWidgets = _.filter(widgets, w => keysByType.gesture.includes(w.key))
    const copyrightWidget = _.find(widgets, w => (
      w.key === CopyrightWidgetConfig.key && w.config['notes'].includes('Copyright')
    ))
    if (copyrightWidget) _.remove(widgets, copyrightWidget)
    // Second half of the same rule: a widget drawn in the common row must not also
    // get a gridster tile. `mobileHide` already keeps most of the common widgets
    // out of the grid, but not show-by (100605) - that omission is why it appeared
    // twice on iPad even when it was not promoted to the page header.
    this.widgets = _.difference(
      widgets, gestureWidgets, headerWidgets, platformSpecific, isCompactLayout ? commonWidgets : []
    )
    // Read the designed layout before gridster or the single-column stacking moves anything
    this.rowGroups = isCompactLayout ? new Map() : this.buildRowGroups(this.widgets)
    this.contentRows = new Map()

    // Empty Space for bottom widget. The grid scrolls only as far as its lowest tile -
    // its padding doesn't count past absolutely positioned items - so this tile is what
    // leaves room under the last widget. It is drawn 10px tall (.du-bottom-spacer in the
    // scss); a tile can't be less than a grid row, which left 30-60px of blank space.
    let emptyBottom:any = {"x": 0,"y": 100,"cols": 50,"rows": 1,"key": 100202,"config": {"widgetKey": 100202,"notes": ``}}
    this.bottomSpacer = emptyBottom
    this.widgets.push(emptyBottom);

    if (isCompactLayout) this.stackWidgetsInSingleColumn()
    const cardRow = [...this.kpiCardWidgets, ...this.informationCardWidgets]
    this.cardTiles = this.widgets.filter(w => cardRow.includes(w))
    // Mobile mode stacks tiles in DOM order and ignores x/y, so keep them in layout order
    this.otherTiles = _.sortBy(this.widgets.filter(w => !cardRow.includes(w)), ['y', 'x'])
    this.narrowGrid = false

    this.commonWidgets = commonWidgets

    // position change
    this.commonWidgets.forEach((w, i) => {
      if (w.key === InfoIconComponent.key) {
        this.commonWidgets.splice(i, 1)
        this.commonWidgets.push(w)
      }
    })
    // position change
    this.commonWidgets.forEach((w, i) => {
      if (w.key === FilterButton.key) {
        this.commonWidgets.splice(i, 1)
        this.commonWidgets.push(w)
      }
    })

    this.ipadBreakpoint()
    this.changedOptions()
    // this.updateScreenSize();
// debugger
    // Page-level API: collect all widgets and initialize PageDataService
    const allPageWidgets = [...this.kpiCardWidgets, ...this.informationCardWidgets, ...this.widgets];
    const pageApiKey = this.pageInfo?.page_api_key || null;
    // if (this.pageInfo?.page_data_service == true) {
    if (this.dashboardKey == "20260310105148" || 
      (this.dashboardKey == "20260209054232" && this.dashboardService.getPageKey[Number(this.tabId)] == "2026020905423241") ||
      (this.dashboardKey == "20260209054232" && this.dashboardService.getPageKey[Number(this.tabId)] == "2026020905423231") ||
      (this.dashboardKey == "20260309071546" && this.dashboardService.getPageKey[Number(this.tabId)] == "2026030907154641") ||
      (this.dashboardKey == "20261005030214" && this.dashboardService.getPageKey[Number(this.tabId)] == "2026100503021411")
    ) {
    this.pageDataService.initializePage(allPageWidgets, this.filterService.baseQuery, pageApiKey);
   } else {
    // Drop the previous tab's page data before this page's widgets initialise, or
    // they read isActive still true and skip their own fetch. The previous tab's
    // ngOnDestroy can't be relied on for this - see there.
    this.pageDataService.reset();
   }
 }

  /**
   * Re-apply `this.options` to gridster.
   *
   * Gridster 20 hung an `api` object off the bound config in ngOnInit, so
   * `options.api.optionsChanged()` pushed in-place mutations synchronously.
   * Gridster 21 moved `api` onto the component (and dropped `optionsChanged`
   * from it), and made options reactive: `options` is an `input.required()` and
   * `$options` a `computed()` over it, with an effect that re-runs setGridSize()
   * and calculateLayout() whenever it changes. A computed is only invalidated by
   * a new *reference*, so mutating `this.options` in place is invisible to it -
   * which is why mobileBreakpoint, compactType and the draggable flips below all
   * stopped taking effect. Re-binding a fresh object is the v21 equivalent.
   */
  changedOptions () {
    this.options = { ...this.options }
  }

  /**
   * Give every grid widget a row of its own on tablet/mobile.
   *
   * The saved layout is a desktop one, so two half-width widgets (cols 25 of the
   * 50-column grid) share a row - too narrow to read on an iPad. Each widget is
   * widened to the full grid and they are stacked in desktop reading order
   * (top-to-bottom, then left-to-right within a row).
   *
   * `rows` is deliberately left alone. With GridType.ScrollVertical gridster derives
   * curRowHeight from curColWidth, and widening the items does not change the grid's
   * column count, so every widget keeps the pixel height it has on desktop - which is
   * what resize()/pushItem() measure against.
   *
   * The array is re-ordered rather than just the y values, because gridster's own
   * mobile mode - which ipadBreakpoint() keeps on for tablet/mobile - lays items
   * out in DOM order and ignores x/y entirely. Doing both keeps the order identical
   * either way.
   *
   * KPI and information cards are untouched: on tablet/mobile they never reach the
   * grid (keysByType.mobileHide), they are rendered in the scrollable card row above it.
   */
  private stackWidgetsInSingleColumn () {
    // Span whatever the grid is already this wide, so curColWidth - and with it the
    // row height - comes out exactly as before.
    const gridColumns = Math.max(this.options.minCols || 0, ..._.map(this.widgets, w => w.x + w.cols))

    this.widgets = _.sortBy(this.widgets, ['y', 'x'])
    let nextY = 0
    this.widgets.forEach(w => {
      w.x = 0
      w.cols = gridColumns
      w.y = nextY
      nextY += w.rows
    })
  }

  /**
   * Keep gridster in its mobile mode on tablet/mobile, at every width.
   *
   * The KPI / information card row in the template is plain content inside
   * <gridster>, in normal flow. Outside mobile mode every gridster-item is
   * absolutely positioned from the top of the grid, so the first tiles land on
   * top of that row and hide it. Mobile mode makes the items position: relative
   * and stacks them after it, which is the horizontally scrolling card row plus
   * one tile per row that stackWidgetsInSingleColumn() prepares for.
   *
   * Gridster enters mobile mode when mobileBreakpoint > its own width. This used
   * to set the breakpoint to the grid's measured width, which is equal, not
   * greater, so it only tripped when the width happened to shrink afterwards -
   * and it mutated options in place, which gridster 21 never sees (see
   * changedOptions). It also read getElementById('gridster'), which during a tab
   * switch can be the previous tab's grid. A breakpoint no width can reach needs
   * no measuring. Only a new options reference is picked up, and re-binding
   * re-runs gridster's layout, so it is re-bound only when the value changes.
   */
  ipadBreakpoint() {
    if (!(this.deviceDetectionService.isTablet || this.deviceDetectionService.isMobile)) return
    if (this.options.mobileBreakpoint === Number.MAX_SAFE_INTEGER) return
    this.options = { ...this.options, mobileBreakpoint: Number.MAX_SAFE_INTEGER }
  }
 
   // Function to detect screen size
  //  updateScreenSize() {
  //    const width = window.innerWidth;
  //    this.isMobile = width >= 251 && width <= 767;
  //    this.isTablet = width >= 768 && width <= 1024;
  //    this.isDesktop = width > 1024;
  //  }

  // Function to detect screen size
  updateScreenSize() {
    const width = window.innerWidth;
    this.isMobile = width >= 251 && width <= 767;
    this.isTablet = width >= 768 && width <= 1024;
    this.isDesktop = width > 1024;
  }

  // Rows a widget's reported content height needs, or 0 when there is no usable height
  private rowsFor (item: GridsterItem, contentHeight?: number): number {
    const node = _.find(item.el.childNodes, { nodeType: Node.ELEMENT_NODE }) as HTMLElement
    const measuredHeight = (contentHeight && contentHeight > 0) ? contentHeight + 20 : node.offsetHeight
    const rows = Math.ceil(measuredHeight / item.gridster.curRowHeight)
    // A widget measured before gridster has laid its tile out (gridster-item is
    // display: none until its first setSize()), or while its only content is an
    // absolutely positioned loader, reports 0 - and rows is NaN while curRowHeight is
    // still 0. kpi-chart does exactly this, once, then stops observing. No such value
    // is a row count gridster accepts, so keep the tile at its configured size.
    return Number.isFinite(rows) && rows >= 1 ? rows : 0
  }

  /**
   * Widgets the designer laid out side by side with the same top and the same height.
   * Each widget sizes its tile to its own content at runtime, so without this a row
   * drifted out of line by however much its contents differed - a cluster bar card
   * next to a donut card ended a grid row apart. resize() keeps each group at the
   * height its tallest member needs. Read from the saved layout, before gridster
   * compacts it.
   */
  private buildRowGroups (widgets: WidgetConfig[]): Map<WidgetConfig, WidgetConfig[]> {
    const groups = new Map<WidgetConfig, WidgetConfig[]>()
    _.forEach(_.groupBy(widgets, w => `${w.y}:${w.rows}`), row => {
      if (row.length > 1) row.forEach(w => groups.set(w, row))
    })
    return groups
  }

  pushItem (item: GridsterItem, rows: number) {
    // The draggable flip has to be live for the synchronous push below, not on the
    // next change-detection pass: GridsterPush.push() calls canBeDragged() on every
    // item it needs to move out of the way, that reads $options().draggable.enabled,
    // and a single false aborts the whole push. Gridster 20's optionsChanged() wrote
    // the grid's own options object; v21 has no such call, and re-binding the input
    // (changedOptions) only lands a tick later, so write $options directly here and
    // restore it afterwards. compactType is no longer flipped here - it is CompactUp
    // in config.ts, which is where the old flip effectively left it anyway.
    const $options = item.gridster.$options()
    const draggableWasEnabled = $options.draggable.enabled
    $options.draggable.enabled = true

    const push = new GridsterPush(item)
    const committedRows = item.$item().rows
    // Write the new row count to the working copy only. checkItemChanges() below
    // compares $item() against item() and returns early when they already agree,
    // so pre-syncing item() here would skip the collision check, the layout
    // recalculation and the item-changed callback - the grid would never
    // recompact and the new size would never be committed. $item() is a memoised
    // computed over the item input; nothing in pushItems() reassigns that input,
    // so the value survives, and gridster mutates $item() in place the same way.
    item.$item().rows = rows
    if (push.pushItems(push.fromNorth)) {
      push.checkPushBack()
      push.setPushedItems()
      item.setSize()
      item.checkItemChanges(item.$item(), item.item())
    } else {
      // The push was refused, so the new size was never committed - put the working
      // copy back. Gridster 20's trailing optionsChanged() re-merged item() into
      // $item() and undid this implicitly; nothing does on v21, so without this the
      // tile kept being drawn at a size gridster had rejected.
      item.$item().rows = committedRows
      push.restoreItems()
    }
    push.destroy()
    $options.draggable.enabled = draggableWasEnabled
    // Deliberately no changedOptions() here. It would re-bind the options input and
    // re-run gridster's effect, and calculateLayout() calls setSize() on every widget
    // - which re-triggers the ResizeObserver each widget emits onSizeChange from, so
    // every tile resize would fan out into another round of resize() calls. The push
    // path already schedules its own relayout via checkItemChanges() ->
    // calculateLayout$.next(). Under gridster 20 the trailing optionsChanged() was
    // what relaid out the grid; here that job belongs to checkItemChanges().
  }

  resize (widgetConfig: WidgetConfig, contentHeight?: number) {
    // The bottom spacer is an empty html-notes tile with a fixed height; its notes'
    // auto-height must not grow it.
    if (widgetConfig === this.bottomSpacer) return
    // A desktop grid in gridster's mobile mode sizes tiles by CSS, not rows (see
    // narrowGrid). Rows worked out there would be wrong once the window widens again.
    if (!this.compactLayout && this.gridster?.mobile) return
    const item = this.gridsterItems?.filter(item => {
      return WidgetService.getId(item.item() as WidgetConfig) === WidgetService.getId(widgetConfig)
    })
    if (!item?.length) return
    const rows = this.rowsFor(item[0], contentHeight)
    if (!rows) return

    const row = this.rowGroups.get(widgetConfig)
    if (!row) {
      item.forEach(m => this.pushItem(m, rows))
      return
    }
    // A widget in a designed row: the whole row takes the tallest content seen so far
    this.contentRows.set(widgetConfig, rows)
    const target = Math.max(...row.map(w => this.contentRows.get(w) || 0))
    this.gridsterItems
      .filter(m => row.includes(m.item() as WidgetConfig))
      .forEach(m => this.pushItem(m, target))
  }

  getCenterBetween () {
    return this.deviceDetectionService.isDesktop ? 'space-between' : 'center'
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.ipadBreakpoint();
    // this.updateScreenSize();

    // gridster 21: the api lives on the component, not on the bound config.
    setTimeout(() => {
      this.gridster?.api.resize();
      this.updateNarrowGrid();
    }, 0);
  }

  ngAfterViewInit () {
    // Gridster decides mobile mode on its first layout, after this view settles
    setTimeout(() => this.updateNarrowGrid())
  }

  // Follow gridster's mobile mode on desktop; see narrowGrid
  private updateNarrowGrid () {
    this.narrowGrid = !this.compactLayout && !!this.gridster?.mobile
  }

  autoiPadHeightFunc() {
    if(this.filterService.singlePage) {
      if(this.widgetService.pageHeaderWidgets.length) {
        return 'calc(100dvh - 119px)';
      } else {
        return 'calc(100dvh - 70px)';
      }
    } else {
      if(this.widgetService.pageHeaderWidgets.length) {
        return 'calc(100dvh - 179px)';
      } else {
        return 'calc(100dvh - 169px)';
      }
    }
  }
  
  ngOnDestroy() {
    // Leaving this page — abort any in-flight widget API calls so they don't
    // keep loading in the background after the user has navigated away.
    // this.requestCancelService.cancelAllRequests();
    // Cancel any in-flight API calls and clear page-level data subscriptions
    // so they don't leak across navigations.
    // Only if this is still the current page. On a tab switch MDC tabs initialise
    // the new tab's grid-page first and destroy this one ~500ms later, once the
    // slide finishes, so an unconditional reset() here wiped the page data the new
    // tab had just set up and its widgets never loaded. The new tab's ngOnInit
    // already reset the previous state; pages.seletedTab moves pageKey before that.
    if (this.filterService.pageKey === this.pageInfo?.page_key) {
      this.pageDataService.reset();
    }
  }
}